export default "__VITE_ASSET__Cj8P3pK3__"